import { render, staticRenderFns } from "./PlayerCarvajal.vue?vue&type=template&id=bf0b8ede&scoped=true&"
import script from "./PlayerCarvajal.vue?vue&type=script&lang=js&"
export * from "./PlayerCarvajal.vue?vue&type=script&lang=js&"
import style0 from "./PlayerCarvajal.vue?vue&type=style&index=0&id=bf0b8ede&lang=scss&scoped=true&"
import style1 from "./PlayerCarvajal.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./PlayerCarvajal.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0b8ede",
  null
  
)

export default component.exports